import {
  Box, Grid, Skeleton, Typography,
} from '@mui/material';
import {
  AreaPlot,
  LinePlot,
  MarkPlot,
  ResponsiveChartContainer,
} from '@mui/x-charts';
import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { colors } from '../../theme';

function ExperienceGraphsLoader() {
  const npsData = useMemo(
    () => [
      { value: 10, date: '03/01/2024' },
      { value: 20, date: '04/01/2024' },
      { value: 30, date: '05/01/2024' },
      { value: 50, date: '06/01/2024' },
      { value: 60, date: '07/01/2024' },
      { value: 81, date: '08/01/2024' },
      { value: 95, date: '09/01/2024' },
    ],
    [],
  );
  const npsDataToChart = useMemo(() => {
    const mappedToDate = npsData.map((nps) => ({
      ...nps,
      date: dayjs(nps.date).valueOf(),
    }));
    return mappedToDate.sort((a, b) => a.date - b.date);
  }, [npsData]);
  return (
    <>
      <Box
        sx={{
          py: 2,
        }}
      >
        <Typography variant="h5" sx={{ mb: 0.5 }}><Skeleton width={400} /></Typography>
        <Typography variant="body2" sx={{ mb: 0.5 }}><Skeleton width={800} /></Typography>
        <Typography variant="body2"><Skeleton width={800} /></Typography>
      </Box>
      <Box>
        <ResponsiveChartContainer
          sx={{
            '.MuiAreaElement-root': {
              fill: colors.grey['100'],
            },
          }}
          height={320}
          series={[
            {
              type: 'line',
              dataKey: 'value',
              label: 'NPS',
              area: true,
              color: colors.grey['100'],
            },
          ]}
          dataset={npsDataToChart as any}
          xAxis={[
            {
              scaleType: 'point',
              dataKey: 'date',
              valueFormatter: (val) => dayjs(val).format('MMM'),
            },
          ]}
        >
          <AreaPlot />
          <LinePlot />
          <MarkPlot />
        </ResponsiveChartContainer>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Skeleton variant="rounded" width={170} height={24} />
        <Skeleton variant="rounded" width={370} height={40} />
      </Box>
      <Grid container spacing={2} sx={{ py: 2 }}>
        {[0, 1, 2, 3, 4, 5].map((item) => (
          <Grid
            item
            xs={6}
            lg={4}
            key={item}
          >
            <Skeleton
              variant="rounded"
              sx={{
                width: '100%',
                height: 'auto',
                aspectRatio: '1',
              }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default ExperienceGraphsLoader;
